import React, { FC } from 'react'
import { InputProps, Input as ChakraInput, useTheme } from '@chakra-ui/react'

import { BasicComponentProps } from '../../common/types'
import { NucbaTheme } from '../../styles'

const Input: FC<BasicComponentProps<InputProps>> = ({ ...rest }) => {
  const { colors } = useTheme<NucbaTheme>()

  return (
    <ChakraInput
      placeholder=' '
      paddingInline={7}
      fontWeight={600}
      fontSize='sm'
      errorBorderColor={colors.nucba.primary}
      focusBorderColor='none'
      autoComplete='off'
      _hover={{
        backgroundColor: 'none',
      }}
      _placeholder={{
        color: colors.nucba['white-30'],
      }}
      {...rest}
    />
  )
}

export default Input
